<template>
	<Card :title="pack.title" :subtitle="`$${formatNumber(pack.price, 2, trans('general.number.decimal'), trans('general.number.thousands'))}`">
		<template #badges>
			<Badge v-if="pack.mandatory" active>{{ trans('events.packs.mandatory') }}</Badge>
			<Badge v-else>{{ trans('events.packs.optional') }}</Badge>
			<i v-if="pack.mandatory" class="fa-solid fa-check-circle text-slate-500 dark:text-slate-600 text-2xl cursor-not-allowed"/>
			<i v-else-if="isSelected" class="fa-solid fa-check-circle text-slate-500 dark:text-slate-600 text-2xl cursor-pointer" @click.stop="emit('selected', pack)"/>
			<i v-else class="fa-regular fa-circle text-gray-400 dark:text-slate-600 text-2xl cursor-pointer" @click.stop="emit('selected', pack)"/>
		</template>
		<List class="max-h-75 overflow-y-auto">
			<ListItem v-for="activity in pack.activities" :title="activity.title" :subtitle="activity.subtitle">
				<template #accessory>
					<div class="flex items-center gap-4 text-sm text-gray-400">
						<div class="flex items-center gap-2">
							<i class="fa-solid fa-calendar-day"/>
							<p>{{ dayjs(activity.begins_at).format(trans('general.dayjs.date')) }}</p>
						</div>
						<div class="flex items-center gap-2">
							<i class="fa-solid fa-clock"/>
							<p>{{ dayjs(activity.begins_at).format(trans('general.dayjs.time')) }} - {{ dayjs(activity.ends_at).format(trans('general.dayjs.time')) }}</p>
						</div>
					</div>
				</template>
				<Badge v-if="activity.mandatory" active>{{ trans('events.packs.mandatory') }}</Badge>
				<Badge v-else>{{ trans('events.packs.optional') }}</Badge>
			</ListItem>
		</List>
	</Card>
</template>
<script setup lang="ts">
import dayjs from 'dayjs'
import {trans} from 'laravel-vue-i18n'
import {formatNumber} from '@/Helpers/general'
import Card from '@/Components/UI/Cards/Card.vue'
import Badge from '@/Components/UI/Badges/Badge.vue'
import {type Pack} from '@/Types/Events/Packs/Pack'
import {computed, type ComputedRef, defineEmits, defineProps, type Ref, ref} from 'vue'
import ListItem from '@/Components/UI/Lists/ListItem.vue'
import List from '@/Components/UI/Lists/List.vue'

const props = defineProps<{
	pack:Pack,
	selectedPacks:Array<Pack>,
}>()

const emit = defineEmits([
	'selected',
])

const pack:Ref<Pack> = ref(props.pack)
const selectedPacks:Ref<Array<Pack>> = ref(props.selectedPacks)

const isSelected:ComputedRef<boolean> = computed(() => {
	return selectedPacks.value.findIndex((p) => p.id === pack.value.id) > -1
})
</script>